<template>
  <div id="app">
    <div class="page_wrap">

      <div class="view_container">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import signup from './modules/sign/signup.vue'
export default {
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>


<style src="./main.less" lang="less"></style>
<style type="text/css" lang="less" scoped>
  
</style>



// WEBPACK FOOTER //
// App.vue?4ecbdd16